import Vue from "vue"
import { MutationTree } from "vuex/types/index";

import { RequestParameters } from "~/utils/SohoApi/SohoApi";
import { extractResourceIds, filterId } from "~/utils/store";

import { VenuesState, VenueResource, VenuesFilter, Venue } from "./venues.types";

interface VenuesMutation {
  params: RequestParameters<Venue, VenuesFilter>
  data: VenueResource[]
}

const mutations: MutationTree<VenuesState> = {
  SET_VENUE (state, resource: VenueResource) {
    const { id } = resource

    Vue.set(state.data, id, resource)
  },

  SET_VENUES (state, { params, data }: VenuesMutation) {
    if (data && data.length <= 0) {
      return
    }

    data.forEach(resource => Vue.set(state.data, resource.id, resource))

    const id = filterId(params)

    Vue.set(state.filters, id, extractResourceIds(data))
  }
}

export default mutations
